<div class="it">
  <div class="it__toolbar">
    <app-search-input label="Search rows"
      class="it__search"
      placeholder="Search name, phone or email"
      [debounce]="200"
      (valueChange)="updateSearchTerm($event)"
    />
    <app-sort-dropdown
      [groups]="sortGroups"
      [selectedValue]="sortCriteria"
      (selectionChange)="updateSortCriteria($any($event))"
    />
  </div>

  <p class="bk-sr-only" role="status">{{ !isFailedView && selectedContacts.length ? selectionLabel : '' }}</p>
  @if (!isFailedView && selectedContacts.length) {
    <div class="it-select" role="region" aria-label="Selected contacts">
      <span class="it-select__count">{{ selectionLabel }}</span>
      <span class="it-select__actions">
        <button type="button" class="it-select__btn" (click)="handleAction('send-sms')">
          <span class="bk-sym" aria-hidden="true">send</span>
          Send SMS
        </button>
        @if (can.manageGroups) {
          <button type="button" class="it-select__btn" (click)="handleAction('move-to-organization')">
            <span class="bk-sym" aria-hidden="true">domain_add</span>
            Add to organization
          </button>
          <button type="button" class="it-select__btn" (click)="handleAction('add-tags')">
            <span class="bk-sym" aria-hidden="true">sell</span>
            Add tags
          </button>
        }
        @if (can.delete) {
          <button type="button" class="it-select__btn is-danger" (click)="handleAction('delete')">
            <span class="bk-sym" aria-hidden="true">delete</span>
            Delete
          </button>
        }
      </span>
      <button type="button" class="it-select__btn it-select__clear" (click)="resetSelectedContacts()">
        Clear selection
      </button>
    </div>
  }

  <div class="bk-panel it__panel">
    <!-- Phones hide the header row, so its select-all moves here. -->
    @if (!isFailedView && pagedContacts.length) {
      <label class="it__selectall">
        <input
          type="checkbox"
          class="it__check"
          [checked]="isAllSelected"
          [indeterminate]="someSelected"
          (change)="toggleSelectAllContacts()"
        />
        Select every contact in this list
      </label>
    }
    <data-table label="Rows that need fixing" [seamless]="true" [maxHeight]="'640px'" [skeletonColumns]="6" [resizable]="false">
      @if (pagedContacts.length) {
        <table class="bk-log">
          <thead>
            <tr>
              @if (!isFailedView) {
                <th scope="col" class="col-check">
                  <input
                    type="checkbox"
                    class="it__check"
                    [checked]="isAllSelected"
                    [indeterminate]="someSelected"
                    (change)="toggleSelectAllContacts()"
                    aria-label="Select every contact in this list"
                  />
                </th>
              }
              <th scope="col" class="col-name">Contact</th>
              <th scope="col" class="col-phone">Phone</th>
              @if (isFailedView) {
                <th scope="col" class="col-issue">Why it failed</th>
              } @else {
                <th scope="col" class="col-groups">Organizations</th>
                <th scope="col" class="col-groups">Tags</th>
              }
              <th scope="col" class="col-actions"><span class="bk-sr-only">Actions</span></th>
            </tr>
          </thead>
          <tbody>
            @for (contact of pagedContacts; track rowKey(contact, $index)) {
              <tr
                class="is-link"
                tabindex="0"
                [class.is-selected]="!isFailedView && isContactSelected(contact)"
                (click)="openContactDetail(contact.personEntity)"
                (keydown.enter)="openFromKeyboard($event, contact)"
              >
                @if (!isFailedView) {
                  <td class="col-check" (click)="$event.stopPropagation()">
                    <input
                      type="checkbox"
                      class="it__check"
                      [checked]="isContactSelected(contact)"
                      (change)="selectContact(contact)"
                      [attr.aria-label]="'Select ' + name(contact)"
                    />
                  </td>
                }
                <td class="col-name">
                  <span class="bk-msg">
                    <span class="bk-msg__subject">{{ name(contact) }}</span>
                    <span class="bk-msg__preview">{{ contact.personEntity.emailAddress || 'No email' }}</span>
                  </span>
                </td>
                <td class="quiet col-phone">{{ contact.personEntity.primaryContactNumber || '—' }}</td>
                @if (isFailedView) {
                  <td class="col-issue">
                    <ul class="it__issues">
                      @for (issue of issues(contact); track $index) {
                        <li>
                          @if ($first) {
                            <app-status [text]="issueText(issue)" status="failed" />
                          } @else {
                            <span class="it__issue-more">{{ issueText(issue) }}</span>
                          }
                        </li>
                      } @empty {
                        <li><app-status text="Rejected when saving" status="failed" /></li>
                      }
                    </ul>
                  </td>
                } @else {
                  <td class="quiet col-groups">{{ groupNames(contact.personEntity.companyEntities) }}</td>
                  <td class="quiet col-groups">{{ groupNames(contact.personEntity.entityTags) }}</td>
                }
                <td class="col-actions">
                  <span class="bk-row-actions">
                    @if (!isFailedView) {
                      <button
                        *hasPermission="{ category: 'CONTACT_MANAGEMENT', permission: 'edit-contacts' }"
                        type="button"
                        class="bk-icon-btn"
                        [attr.aria-label]="'Edit ' + name(contact)"
                        matTooltip="Edit"
                        (click)="$event.stopPropagation(); openEditContact(contact.personEntity)"
                      >
                        <span class="bk-sym" aria-hidden="true">edit</span>
                      </button>
                    }
                    <span class="bk-sym fb-go" aria-hidden="true">chevron_right</span>
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <app-empty-state
          [icon]="isFailedView ? 'check_circle' : 'contacts'"
          [message]="isFailedView ? 'Nothing failed in this import' : 'No contacts were added'"
          [hint]="isFailedView ? '' : 'Check the Failed tab and the skipped count above.'"
          [query]="searchTerm"
          size="medium"
          (clear)="clearSearch()"
        />
      }
    </data-table>
  </div>

  @if (getFilteredContacts.length > pageSize) {
    <div class="it__pager">
      <app-pagination
        [totalPages]="totalPages"
        [currentPage]="currentPage"
        [totalItems]="getFilteredContacts.length"
        [pageSize]="pageSize"
        (changePage)="goToPage($event)"
        (onNext)="nextPage()"
        (onPrev)="prevPage()"
        (pageSizeChange)="changePageSize($event)"
      />
    </div>
  }

  <!-- MODALS -->
  @if (showContactDetail) {
    <contact-detail [isLocalContacts]="isFailedView" (closeModal)="closeContactDetail()" [contact]="selectedContact" />
  }

  @if (openEditContactModal) {
    <edit-contact-modal [selectedContact]="selectedContact" (closeModalEvent)="closeEditContact()" />
  }

  <assign-multiple-contacts-to-organizations
    [open]="showAssignMultipleContactsToOrg"
    (close)="closeAssignMultipleContactsToOrg()"
    [selectedContacts]="selectedContactsForModals"
    (resetSelectedContacts)="resetSelectedContacts()"
  />

  <assign-multiple-contacts-to-tags
    [open]="showAssignMultipleContactsToTags"
    (close)="closeAssignMultipleContactsToTags()"
    [selectedContacts]="selectedContactsForModals"
    (resetSelectedContacts)="resetSelectedContacts()"
  />

  <app-prompt-card
    [buttonText]="selectedContacts.length === 1 ? 'Delete contact' : 'Delete ' + selectedContacts.length + ' contacts'"
    [title]="selectedContacts.length === 1 ? 'Delete this contact?' : 'Delete ' + selectedContacts.length + ' contacts?'"
    tone="danger"
    impact="They were just added. Deleting removes them from your contacts. This cannot be undone."
    impactIcon="warning"
    [openModal]="showDeleteSelectedContactsPrompt"
    (onClose)="closeDeleteSelectedContactsPrompt()"
    (onButtonClick)="deleteSelectedContacts()"
    [loading]="contactService.isLoading"
  >
    <p class="it__prompt">The selected contacts will be removed from your contacts, organizations and tags.</p>
  </app-prompt-card>
</div>
